import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)
    this.cover = this.el.querySelector('.c-objectives_cover')
    this.miniCover = this.el.querySelector('.c-objectives_header_miniCover')

    this.coverVideo = this.cover.querySelector('video')
    this.miniCoverVideo = this.miniCover.querySelector('video')

    this.isLoaded = false
  }

  toggleCover(e) {
    if (!this.coverVideo)
      return

    if (e.way === 'enter') {
      if (!this.isLoaded) {
        this.loadAndPlay(this.coverVideo)
        this.loadAndPlay(this.miniCoverVideo)
      }
      else {
        this.play()
      }
    }
    else {
      this.pause()
    }
  }

  play() {
    this.coverVideo.play()
    this.miniCoverVideo.play()
  }

  pause() {
    this.coverVideo.pause()
    this.miniCoverVideo.pause()
  }

  loaded(elt) {
    elt.parentNode.classList.add('-loaded')
  }

  loadAndPlay(elt) {
    const source = elt.querySelector('source[data-src]')

    if (source) {
      elt.$onCanPlayThrough = () => {
        this.play()
        this.isLoaded = true
        this.loaded(elt)
      }

      source.setAttribute('src', source.getAttribute('data-src'))
      source.removeAttribute('data-src')
      elt.addEventListener(
        'canplaythrough',
        elt.$onCanPlayThrough,
        { once: true }
      )
      elt.load()
    }
  }

  destroy() {
    for (const elt of [this.coverVideo, this.miniCoverVideo]) {
      if (elt.$onCanPlayThrough) {
        elt.removeEventListener('canplaythrough', elt.$onCanPlayThrough)
      }
    }
  }
}
